import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TableBodyInterface, TableRowItem } from '@components/components/table/table.interface';

@Component({
  selector: 'sp-table-body',
  standalone: false,
  templateUrl: './table-body.component.html',
  styleUrls: ['./table-body.component.scss']

})
export class TableBodyComponent implements OnInit, TableBodyInterface {
  constructor() {}
  @Input() header = [];
  @Input() rows = [];
  @Input() query = null;
  @Input() basicQuery = null;
  @Input() dateQuery = null;
  @Input() DataService = null;
  @Input() withCheckbox: boolean;
  @Output() propagateCheck = new EventEmitter();
  loading = true;

  cancelTableForm(row) {
    row.form = !row.form;
  }

  generateFormGroup(row) {
    return row.formGroup || new UntypedFormGroup({});
  }

  submitTableForm(row, id, formGroup, submitType = 'PUT') {
    if (formGroup.invalid) {
      // call toaster to add error;
      // add error clases for inputs;
      return false;
    }
    switch (submitType) {
      case 'POST':
        this.DataService.create(formGroup);
        break;
      case 'PUT':
        // console.log(formGroup);
        this.DataService.update(id, formGroup);
        break;
      case 'GET':
        // this.DataService.create(formGroup);
        break;
      case 'DELETE':
        // this.DataService.create(id);
        break;
    }
    this.cancelTableForm(row);
  }

  async buildForm() {
    if (this.rows?.length) {
      await this.rows.forEach(row => {
        row.formGroup = new UntypedFormGroup({});
        row.cells.forEach(cell => {
          if (cell.input) {
            row.formGroup.addControl(cell.input.name, new UntypedFormControl(cell.title));
          }
          if (cell.sendDataInput) {
            row.formGroup.addControl(cell.sendDataInput.name, new UntypedFormControl(cell.sendDataInput.name));
          }
          if (cell.buttons) {
            const formGroupEnabled = cell.buttons.find(thisCell => thisCell.hasOwnProperty('formGroup'));
            if (formGroupEnabled !== undefined) {
              formGroupEnabled.fields.forEach(field => {
                formGroupEnabled.formGroup.addControl(field.name, new UntypedFormControl(cell.name));
              });
            }
          }
        });
      });
      this.loading = false;
    }
  }

  getCheckedRow(check: boolean, row: TableRowItem) {
    row.selected = check;
    this.propagateCheck.emit();
  }

  isOdd(index) {
    return Boolean(index % 2);
  }

  async ngOnInit() {
    await this.buildForm();
  }
}